<template>
	<div v-if="is_load" class="bg-gradient-primary user_profile bd-callout bd-callout-info position-relative px-2 p-1">
		<div class="d-flex flex-row pt-2 pb-1">
			<span class="status">
				<picture v-if="parseInt(cur_user.id) > 0">
					<source :srcset="user_avatar_template | get_image_from_template(150,150,'webp')" type="image/webp"/>
					<source :srcset="user_avatar_template | get_image_from_template(150,150,'png')" type="image/png"/>
					<img :src="user_avatar_template | get_image_from_template(150,150,'png')"
						 @click="show_profile"
						 class="profile-image rounded-circle d-inline-block cursor-pointer" />
				</picture>
			</span>

			<div class="user_attrib ml-3">
				<div class="name d-block fw-700 text-dark">{{ user_name }}</div>
				<div class="company small text-dark">{{ user_company }}</div>
				<div class="dolznost small text-dark">{{ user_dolznost }}</div>

				<span v-if="is_user_name_redirect" class="small fw-700 text-dark">{{user_name_redirect_output}}</span>
				<div class="vacation" v-if="show_vacation">
					<vacation :id=parseInt(this.u_user.id)></vacation>
				</div>
			</div>
		</div>

		<span class="rem_user_ins btn btn-icon btn-sm btn-danger shadow waves-effect waves-themed cursor-pointer" v-if="can_del" v-on:click="close">
            <i class="fal fa-times"></i>
        </span>

	</div>
</template>

<script>
import vacation from "./vacation.vue";

export default {
	name: "UserBlock",
	props: {
		user_id: {
			type: Number,
			default: 0
		},

		can_del : {
			type : Boolean,
			default:false
		},

		cur_status : {
			type : String,
			default : "status",
		},

		user : {
			type : Object,
			default :  () => {}
		} ,

		del_triger : {
			type : String,
			default :  ''
		},

		padding_class : {
			type : String,
			default :  'px-2 pt-2 pb-2'
		},

		show_vacation : {
			type : Boolean,
			default:false
		},
	},

	components : {
		vacation
	},

	data() {
		return {
			is_load: true,
			u_user: this.user
		}
	},
	mounted() {
		if (this.user_id > 0) {
			this.load_user();
		}
	},
	methods: {
		show_profile() {
			EventBus.$emit('click_user_photo', this.cur_user_id);
		},

		async get_user(user_id) {
			return api.get(`/user/${parseInt(user_id)}`);
		},

		close() {
			if (this.del_triger?.length > 0) {
				EventBus.$emit(this.del_triger,JSON.parse(JSON.stringify(this.u_user)));
			}
			this.u_user = {};
			this.user_id = 0;
		},

		async load_user() {
			this.is_load = false;
			try {
				const { data } = await this.get_user(this.user_id);
				if (data.status === "operation_success") {
					this.is_load = true;
					this.u_user = data.data;
				}
			} catch (err) {
				EventBus.$emit('show_toast', { err: err.message, type: "danger", title: err.name });
			}
		}
	},
	computed: {
		cur_user() {
			if(this.obj_to_null(this.u_user) != null) {
				return this.u_user;
			}

			return {
				"id" : 0,
				'name' : "",
				"company" : "",
				"department" : "",
			}
		},

		cur_user_id() {
			return parseInt(this.u_user.id);
		},

		user_company() {
			return `${this.cur_user.company}, ${this.cur_user.department}`;
		},

		user_name() {
			return this.cur_user.name;
		},

		user_dolznost() {
			return this.cur_user.dolznost;
		},

		user_avatar() {
			return this.cur_user.avatar || null;
		},

		user_avatar_template() {
			return this.user_avatar?.template || "";
		},
		is_user_name_redirect(){
			return this.user_name_redirect !== '';
		},
		user_name_redirect() {
			return this.user?.user_name_redirect ?? '';
		},
		user_name_redirect_output() {
			return 'Виконується переадресація службових з ' + this.user_name_redirect;
		},
	},
	watch: {
		user(value) {
			this.u_user = value;
			this.is_load = true;
		},

		user_id(value) {
			this.load_user();
		},

		del_triger(value) {
			this.u_del_tr = value;
		}
	}
}
</script>

<style scoped>
.rem_user_ins {
	position:absolute;
	top:8px;
	right: 15px;
}
</style>
